import { render, staticRenderFns } from "./sharia_dzikirpagi.vue?vue&type=template&id=d3477d1e"
import script from "./sharia_dzikirpagi.vue?vue&type=script&lang=js"
export * from "./sharia_dzikirpagi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports